import React from 'react';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';
import ProfilePage from './ProfilePage';

const Profile: React.FC = () => {
  return (
    <ProtectedRoute>
      <ProfilePage />
    </ProtectedRoute>
  );
};

export default Profile; 